export const DIRECT_CONTACT = "Direct Contact";
export const CONTACT_FORM = "Contact Form";
export const CP_DC_2 = "CP-DC-2";
export const BOARD = "Board";
export const ADMIN = "Admin";
export const CS_50DIRECT_SALES = "CS-50/Direct Sales";
export const MARKETS = "Markets";
export const CA_12_BCC = "CA-12-BCC";
